<template>
    <div v-if="checkAuthorization.passAccount">
        <v-row>
            <v-col>
                <Tabs :tabs="tabs" />
            </v-col>
        </v-row>
        <router-view></router-view>
    </div>
</template>

<script>
import Tabs from '@components/Tabs';
import { api } from '@utils/api';

export default {
    components: {
        Tabs
    },
    data() {
        return {
            passwordNotices: [],
            tabs: [
                {
                    title: 'passAccount.header.userInfoTitle',
                    route: '/accMgmt',
                    id: 'userInfoTab'
                },
                {
                    title: 'passAccount.header.myPassword',
                    route: '/accMgmt/password',
                    id: 'myPasswordTab'
                },
                {
                    title: 'passAccount.header.mySecretQuestions',
                    route: '/accMgmt/secretquestions',
                    id: 'secretquestionsTab'
                }
            ]
        };
    },
    methods: {
        async loadPasswordPage() {
            const notices = await api.get('notices', null, { withCredentials: true });
            this.$store.commit('setNotices', notices);
        },
        async loadSecretQuestions() {
            const secretQuestions = await api.get('secretQuestions', null, { withCredentials: true });
            this.$store.commit('setSQ', secretQuestions);
        }
    },
    async mounted() {
        await this.loadPasswordPage();
        await this.loadSecretQuestions();
    },
    computed: {
        checkAuthorization() {
            return {
                passAccount:
                    this.$store.state.aclConfig.userRoles?.standard ||
                    this.$store.state.aclConfig.authorization?.superAdmin ||
                    this.$store.state.aclConfig.userRoles?.superAdmin
            };
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.service {
    cursor: pointer;
    border-top: 7px solid #fff;
    .v-card__subtitle {
        padding-top: 10px;
        padding-bottom: 21px;
    }
    .goto {
        color: $primary;
        border-radius: 50% !important;
        position: absolute;
        right: 10px;
        bottom: 20px;
    }
    &:hover {
        border-top: 7px solid $primary;
        .goto {
            background-color: $primary;
            color: #fff;
        }
    }
}
</style>
